import { useRef } from 'react';

export function SearchBar({ value, onChange, placeholder = 'Search…' }) {
  const ref = useRef(null);
  return (
    <div className="search-bar" onClick={() => ref.current?.focus()}>
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M17 17l-3.5-3.5M15 9A6 6 0 11 3 9a6 6 0 0112 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      <input
        ref={ref}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
      {value && (
        <button
          className="btn-icon"
          style={{ padding: 0, minHeight: 'unset', width: 14 }}
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          ✕
        </button>
      )}
    </div>
  );
}
